import { ReceiptEmailTemplate } from "../../../models/EmailTemplate";
import { Language } from "../../../models/Translation";
import { EditableEmailTemplate, EmailTemplateMinimal } from "./types";

export const toEditableTemplate = (
  templates: ReceiptEmailTemplate[],
  languages: ReadonlyArray<Language>
): EditableEmailTemplate => {
  return {
    tenantId: templates[0]?.tenantId || "",
    senderName: templates[0]?.senderName || "",
    senderEmail: templates[0]?.senderEmail || "",
    description: templates[0]?.description || "",
    templates: templatesFromLanguages(templates, languages)
  };
};

const templatesFromLanguages = (
  templates: ReceiptEmailTemplate[],
  languages: ReadonlyArray<Language>
): EmailTemplateMinimal[] => {
  return languages.map(lang => {
    let tmp = templates.find(t => t.languageCode === lang.code);
    if (tmp) {
      return {
        id: tmp.id,
        languageCode: tmp.languageCode,
        languageName: lang.name,
        sendGridTemplateId: tmp.sendGridTemplateId,
        created: tmp.created,
        updated: tmp.updated
      } as EmailTemplateMinimal;
    }
    return {
      id: null,
      languageCode: lang.code,
      languageName: lang.name,
      sendGridTemplateId: null
    } as EmailTemplateMinimal;
  });
};

export const toReceiptEmailTemplates = (
  editableTemplate: EditableEmailTemplate
): ReceiptEmailTemplate[] => {
  return editableTemplate.templates.map(t => {
    return {
      id: t.id || null,
      tenantId: editableTemplate.tenantId,
      senderName: editableTemplate.senderName,
      senderEmail: editableTemplate.senderEmail,
      description: editableTemplate.description,
      sendGridTemplateId: t.sendGridTemplateId,
      languageCode: t.languageCode,
      created: t.created,
      updated: t.updated
    } as ReceiptEmailTemplate;
  });
};
